import { useRoute } from "preact-iso";
import "./Category.scss";
import { useEffect, useState } from "preact/hooks";
import { fetchCategory } from "../../services/coupon.service";
import CouponComponent, { Coupon } from "../Coupons/Coupon/Coupon";
import { categories } from "./Categories";

const CategoryComponent = () => {
  const { params } = useRoute();
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const category = categories.find(c => c.id === params?.categoryID);
  const categoryTitle = category?.title || "Coupons";

  useEffect(() => {
    document.title = `${categoryTitle} Coupons in Utah County — EZ Coupons`;
  }, [categoryTitle]);

  useEffect(() => {
    if (!params?.categoryID) {
      setLoading(false);
      return;
    }
    fetchCategory(params.categoryID)
      .then(res => {
        if (res?.data) setCoupons(res.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [params?.categoryID]);

  return (
    <div className={"category-container"} id="category-container">
      <h1 class={"category-title"}>{categoryTitle}</h1>
      {loading ? (
        <p class="category-empty">Loading coupons…</p>
      ) : coupons.length === 0 ? (
        <p class="category-empty">No coupons found in this category right now — check back soon.</p>
      ) : (
        <div className={"category-coupons"}>
          {coupons.map((coupon, index) => <CouponComponent key={coupon.CouponID || index} coupon={coupon} />)}
        </div>
      )}
    </div>
  );
};

export default CategoryComponent;
